import { render } from "./ServiciosPage.vue?vue&type=template&id=79321712&scoped=true"
import script from "./ServiciosPage.vue?vue&type=script&lang=js"
export * from "./ServiciosPage.vue?vue&type=script&lang=js"

import "./ServiciosPage.vue?vue&type=style&index=0&id=79321712&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79321712"]])

export default __exports__